var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.501 2.03695C14.8309 0.661746 12.9006 -0.463419 10.6553 0.191677C9.58235 0.501592 8.64624 1.16621 7.99989 2.07695C7.35354 1.16621 6.41743 0.501592 5.3445 0.191677C3.09417 -0.453418 1.16888 0.661746 0.498786 2.03695C-0.441352 3.96223 -0.0512946 6.12755 1.65896 8.4729C2.99915 10.3082 4.91444 12.1684 7.69484 14.3288C7.78271 14.3973 7.89095 14.4345 8.00239 14.4345C8.11382 14.4345 8.22207 14.3973 8.30994 14.3288C11.0853 12.1734 13.0056 10.3282 14.3458 8.4729C16.0511 6.12755 16.4411 3.96223 15.501 2.03695V2.03695Z",
    fill: "#FD1D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/likeIcon.9d5ac1098419e7b536650dd8927392f4.svg";
export { ForwardRef as ReactComponent };